module.exports = __webpack_public_path__ + "img/cash.d3b5f51a.svg";